import { InspectorControls } from "@wordpress/block-editor";
import { PanelBody, ColorPalette } from "@wordpress/components";
import { t } from "drupal";
import { debug } from '../utilities/helpers';

function AccordionContainerSidePanel({ attributes, setAttributes }) {
  const { backgroundColorClass = "" } = attributes;

  const backgroundOptions = [
    { name: "Purple", color: "#32006e", class: "purple" },
    { name: "Dark Grey", color: "#404040", class: "darkgrey" },
    { name: "Lite Grey", color: "#e5e5e5", class: "litegrey" },
    { name: "White", color: "#ffffff", class: "white" },
  ];

  // debug("Accordion Parent - Side Panel", { backgroundColorClass});

  const onChangeBackground = (colorHexOrClass) => {
    const selected = backgroundOptions.find(opt => opt.color === colorHexOrClass);
    if (selected) {
      setAttributes({ backgroundColorClass: selected.class });
    }
  };

  return (
    <InspectorControls>
      <PanelBody title={t("Accordion Settings")} initialOpen>
        <ColorPalette
          colors={backgroundOptions}
          value={backgroundOptions.find(opt => opt.class === backgroundColorClass)?.color}
          onChange={onChangeBackground}
          label={t("Background Color")}
        />
      </PanelBody>
    </InspectorControls>
  );
}

export default AccordionContainerSidePanel;
